import React from "react";
import { Badge, Card, Space, Table, Tooltip } from "antd";
import AircraftTag from "../../../components/AircraftTag";
import { formatDateTime } from "../../../utils/dateUtils";
import AirlineIngestDraftRowActions from "./AirlineIngestDraftRowActions";
import { INGEST_STATUS_MAP, ingestAircraftRegs, ingestRowKey } from "./ingestListPresentation";
import "./AirlineIngestWorkspacePanel.css";

export default function AirlineIngestWorkspacePanel({ tasks, onReview, onRetry, onDiscard }) {
    const items = tasks || [];
    if (items.length === 0) {
        return null;
    }

    const columns = [
        {
            title: "文件",
            dataIndex: "file_name",
            key: "file_name",
            ellipsis: true,
            render: (text, record) => (
                <a
                    onClick={(event) => {
                        event.preventDefault();
                        if (record.status === "pending_review") {
                            onReview(record.id);
                        }
                    }}
                >
                    {text || "航司班期接入"}
                </a>
            ),
        },
        {
            title: "飞机",
            key: "aircraft",
            width: 280,
            onCell: () => ({ className: "ingest-aircraft-cell" }),
            render: (_, record) => {
                const regs = ingestAircraftRegs(record);
                if (!regs.length) {
                    return <span style={{ color: "#999" }}>识别中可先空</span>;
                }
                return (
                    <Space size={[4, 4]} wrap className="ingest-aircraft-tags">
                        {regs.map((reg) => (
                            <AircraftTag key={reg} registration={reg} />
                        ))}
                    </Space>
                );
            },
        },
        {
            title: "航班",
            key: "flight_count",
            width: 80,
            align: "right",
            render: (_, record) => (Array.isArray(record.draft_flights) ? record.draft_flights.length : 0),
        },
        {
            title: "状态",
            dataIndex: "status",
            key: "status",
            width: 100,
            render: (text, record) => {
                const status = INGEST_STATUS_MAP[text] || { status: "default", text };
                return (
                    <Tooltip title={record.error_message || ""}>
                        <Badge className="status-badge" status={status.status} text={status.text} />
                    </Tooltip>
                );
            },
        },
        {
            title: "更新时间",
            dataIndex: "updated_at",
            key: "updated_at",
            width: 160,
            render: (text) => (text ? formatDateTime(text) : "未知"),
        },
        {
            title: "操作",
            key: "action",
            width: 160,
            render: (_, record) => (
                <AirlineIngestDraftRowActions record={record} onReview={onReview} onRetry={onRetry} onDiscard={onDiscard} />
            ),
        },
    ];

    return (
        <Card className="data-card" style={{ marginBottom: 12 }} title={`航司班期接入（${items.length}）`}>
            <Table
                size="small"
                pagination={false}
                rowKey={ingestRowKey}
                columns={columns}
                dataSource={items}
            />
        </Card>
    );
}
